export function setSimplebar() {
  let isEnabled = false;
  const instances = new Map(); // 各インスタンスのクリーンアップ関数を管理
  let currentDraggingInstance = null; // 現在ドラッグ中のインスタンスを追跡

  // _variables.scss の $bp_smartphone_max と同値
  const SMARTPHONE_MAX = 768;

  function enableSimplebarDrag() {
    isEnabled = true;
    
    const containers = document.querySelectorAll('[data-simplebar]');

    containers.forEach((container, index) => {
      // 多重登録防止: すでに管理下のコンテナは無視
      if (instances.has(container)) {
        return;
      }

      const sb = SimpleBar.instances.get(container);
      if (!sb) {
        return; // SimpleBarがまだ生成されていない場合は次回リサイズ時に再試行
      }

      // 処理中フラグとして仮登録
      instances.set(container, null);

      setTimeout(() => {
        // 待機中に無効化されていたら中止
        if (!isEnabled) {
          instances.delete(container);
          return;
        }

        const wrapper = sb.getScrollElement();
        // セレクタを厳密化（直下のトラックを探すイメージで）
        // ※SimpleBarのDOM構造に依存しますが、通常はcontainer内のこのクラスで特定可能です
        const track = container.querySelector('.simplebar-track.simplebar-horizontal');
        const thumb = track ? track.querySelector('.simplebar-scrollbar') : null;

        if (!track || !thumb) {
          instances.delete(container);
          return;
        }

        // リロード時のちらつきを防ぐため、初期化中は非表示
        container.style.visibility = 'hidden';

        const viewportWidth = window.innerWidth;
        const isSmartphone = viewportWidth <= SMARTPHONE_MAX;

        if (isSmartphone) {
          // SP のみ: CSS の width: calc(100% + 30px) をビューポート基準に制限する
          // タブレット(769-1024px)はスケール後の1160pxレイアウト基準のCSS自然幅をそのまま使う。
          // タブレットで viewport - 30 を設定すると CSS 自然幅(約920px)と乖離し、
          // SimpleBr の contentWrapperEl.offsetWidth と elStyles.width が不一致になるため設定しない。
          const targetWidth = viewportWidth - 30;
          container.style.width = `${targetWidth}px`;
          container.style.maxWidth = `${targetWidth}px`;
        }

        // SimpleBarに再計算を実行させる
        setTimeout(() => {
          if (sb.recalculate) {
            sb.recalculate();
            
            // 再計算完了後に表示
            container.style.visibility = 'visible';
          }
        }, 100);

        // --- ドラッグ操作の誤動作を防ぐためのスタイル適用 ---
        track.style.pointerEvents = 'auto'; // トラックへの操作を確実に有効化
        thumb.style.cursor = 'grab';

        // --- このインスタンス専用の独立した状態変数 (ここが重要) ---
        // constで宣言することで、このクロージャ内だけのローカル変数になります
        const state = {
          isDragging: false,
          startX: 0,
          startScroll: 0
        };

        // --- イベントハンドラー ---

        const onMove = (e) => {
          // 【複数インスタンス対応】このインスタンスがドラッグ中でなければ何もしない
          if (currentDraggingInstance !== container) return;
          if (!state.isDragging) return;
          
          // 【重要修正1】ブラウザ標準のドラッグ/選択動作をキャンセルし、画面スクロールを防ぐ
          e.preventDefault();
          e.stopPropagation();

          // マウスとタッチの座標取得の統一
          const clientX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;

          // 【重要修正2】pageXではなくclientX(画面上の座標)を使って計算ズレを防ぐ
          const dx = clientX - state.startX;
          
          const scrollableWidth = wrapper.scrollWidth - wrapper.clientWidth;
          const thumbMovableWidth = track.clientWidth - thumb.clientWidth;

          if (thumbMovableWidth > 0) {
            // 比率計算でスクロール位置を更新
            wrapper.scrollLeft = state.startScroll + dx * (scrollableWidth / thumbMovableWidth);
          }
        };

        const onEnd = (e) => {
          // 【複数インスタンス対応】このインスタンスがドラッグ中でなければ何もしない
          if (currentDraggingInstance !== container) return;
          if (!state.isDragging) return;
          
          if (e) {
            e.preventDefault();
            e.stopPropagation();
          }
          
          state.isDragging = false;
          currentDraggingInstance = null; // ドラッグ終了時にリセット
          
          thumb.style.cursor = 'grab';
          document.body.style.userSelect = ''; // テキスト選択禁止を解除
          document.body.style.cursor = '';

          // グローバルイベントの削除
          document.removeEventListener('mousemove', onMove);
          document.removeEventListener('mouseup', onEnd);
          document.removeEventListener('touchmove', onMove);
          document.removeEventListener('touchend', onEnd);
        };

        const onStart = (e) => {
          // 【修正】マウスイベントの場合のみ左クリック(button 0)チェック
          if (e.type === 'mousedown' && e.button !== 0) return;
          
          // 【複数インスタンス対応】既に他のインスタンスがドラッグ中なら無視
          if (currentDraggingInstance !== null && currentDraggingInstance !== container) {
            return;
          }

          // 親要素へのイベント伝播を止める（入れ子のSimpleBar対策）
          e.stopPropagation();

          // テキスト選択などブラウザ標準動作を抑制
          // e.preventDefault(); // ここで呼ぶとクリックが効かなくなる場合があるので注意（状況による）

          state.isDragging = true;
          currentDraggingInstance = container; // このインスタンスをドラッグ中としてマーク
          
          // pageXではなくclientXを使用
          state.startX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
          state.startScroll = wrapper.scrollLeft;

          thumb.style.cursor = 'grabbing';
          document.body.style.userSelect = 'none'; // ドラッグ中のテキスト選択防止
          document.body.style.cursor = 'grabbing'; // 画面外に出たときもカーソル維持

          if (e.type.includes('touch')) {
            document.addEventListener('touchmove', onMove, { passive: false });
            document.addEventListener('touchend', onEnd);
          } else {
            document.addEventListener('mousemove', onMove, { passive: false });
            document.addEventListener('mouseup', onEnd);
          }
        };

        // イベントリスナー登録
        track.addEventListener('mousedown', onStart);
        track.addEventListener('touchstart', onStart, { passive: false });

        // クリーンアップ関数（リサイズ時などで破棄するため）
        const cleanup = () => {
          track.removeEventListener('mousedown', onStart);
          track.removeEventListener('touchstart', onStart);
          
          // ドラッグ中に破棄された場合も考慮してdocument側のリスナーも消す
          document.removeEventListener('mousemove', onMove);
          document.removeEventListener('mouseup', onEnd);
          document.removeEventListener('touchmove', onMove);
          document.removeEventListener('touchend', onEnd);
          
          // 【複数インスタンス対応】このインスタンスがドラッグ中だった場合はリセット
          if (currentDraggingInstance === container) {
            currentDraggingInstance = null;
          }
          
          // スタイルリセット
          document.body.style.userSelect = '';
          document.body.style.cursor = '';
        };

        instances.set(container, cleanup);

      }, 50);
    });
  }

  function disableSimplebarDrag() {
    if (!isEnabled) return;
    isEnabled = false;

    instances.forEach((cleanup, container) => {
      // スタイルを元に戻す（SP で設定したインラインスタイルをクリア）
      if (container && container.style) {
        container.style.visibility = '';
        container.style.width = '';
        container.style.maxWidth = '';
      }
      if (typeof cleanup === 'function') cleanup();
    });
    instances.clear();
    currentDraggingInstance = null; // グローバル状態をリセット
  }

  // リサイズ時に幅を更新する関数
  function updateContainerWidths() {
    const viewportWidth = window.innerWidth;
    const isSmartphone = viewportWidth <= SMARTPHONE_MAX;
    
    instances.forEach((cleanup, container) => {
      if (container && container.style) {
        if (isSmartphone) {
          // SP: ビューポート基準の幅に更新
          const targetWidth = viewportWidth - 30;
          container.style.width = `${targetWidth}px`;
          container.style.maxWidth = `${targetWidth}px`;
        } else {
          // タブレット: インラインスタイルをクリアしてCSS自然幅に委ねる
          container.style.width = '';
          container.style.maxWidth = '';
        }

        // SimpleBarインスタンスを取得して再計算
        const sb = SimpleBar.instances.get(container);
        if (sb && sb.recalculate) {
          sb.recalculate();
        }
      }
    });
  }

  function checkAndUpdate() {
    // 1024px以下なら有効化
    if (window.innerWidth <= 1024) {
      if (isEnabled) {
        // 既に有効な場合は幅のみ更新
        updateContainerWidths();
      } else {
        // 無効な場合は有効化
        enableSimplebarDrag();
      }
    } else {
      disableSimplebarDrag();
    }
  }

  // DOMContentLoadedイベントが既に発火済みか確認
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      checkAndUpdate();
    });
  } else {
    // 少し遅延を入れてSimpleBarの自動初期化を待つ
    setTimeout(() => {
      checkAndUpdate();
    }, 100);
  }
  
  window.addEventListener('resize', checkAndUpdate);
}
